export default __webpack_public_path__ + "static/media/Collapse-in.984c53a8.svg";